import { order } from './order';
import { payment } from './payment';
import { store } from './store';
import { user } from './user';
import { whitelabel } from './whitelabel';

export const endpoints = { order, payment, store, user, whitelabel };
